module.exports = __webpack_public_path__ + "static/media/mtto_seguridad.18dc2d96.svg";